<div class="content">
  <h4 class="icon-title">
    <mat-icon class="mat-icon-resultado">description</mat-icon>
    <span class="title-alert">Pré-cargas excedeu limite máximo viagem motorista</span>
  </h4>
  <br>
  <div class="modal-content">
    <div *ngFor="let preCarga of preCargasVisualizacao" class="pre-carga-container">
      <div class="row">
        <div class="col-5">
          <label>Destino: {{ preCarga.destino }}</label>
        </div>
        <div class="col-7">
          <label>Motorista: {{ preCarga.motorista }}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label>Veiculo: {{ preCarga.veiculo }}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label>Entregas: {{ preCarga.qtdEntregas }} - Valor: {{ preCarga.valor  | currency: "BRL" }} -
            Peso: {{ preCarga.peso | capacidadeFormater : 'kg' : 2 }} -
            Volume: {{ preCarga.volume | capacidadeFormater : 'm³' : 2 }}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label [innerHTML]="obterHorasExcedidoViagem(preCarga)"></label>
        </div>
      </div>
    </div>
  </div>
  <button
    mat-raised-button
    style="margin-top: 10px"
    color="primary"
    (click)="podeProsseguir()">
    <i class="fas fa-save"></i> Manter mesmo assim.
  </button>
  <button
    mat-raised-button
    style="margin-top: 10px; margin-left: 10px"
    color="warn"
    (click)="naoPodeProsseguir()">
    <i class="la la-times"></i> Não manter, remover.
  </button>

</div>
